<template>
  <div class="right">
    <el-button
      type="danger"
      size="mini"
      icon="el-icon-delete"
      :loading="loading"
      @click="confirm_truncate"
    >
      Truncate Xero IDs
    </el-button>
  </div>
</template>

<script>
import { truncate_xero_ids } from '../../api/xero';

export default {
  name: 'TruncateXeroIdsButton',
  data() {
    return {
      loading: false
    };
  },
  methods: {
    confirm_truncate() {
      this.$confirm(
        'This will permanently set all Xero-related IDs (like xero_contact_id, xero_invoice_id, etc.) to NULL in your database for a different xero organization. Are you sure?',
        'Confirm Truncate',
        {
          confirmButtonText: 'Yes, truncate all',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => this.truncate_xero_ids())
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Action canceled.'
          });
        });
    },
    async truncate_xero_ids() {
      this.loading = true;
      try {
        const response = await truncate_xero_ids(this);
        this.$message({
          type: 'success',
          message: response.data.message || 'All Xero IDs have been cleared.'
        });
      } catch (error) {
        console.error(error);
        this.$message({
          type: 'error',
          message: error.response?.data?.error || 'An error occurred while truncating Xero IDs.'
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
